export default __webpack_public_path__ + "static/media/apple-cut@3x.97ba43aa.png";